//PORTED FROM ANOTHER PROJECT
var bts = angular.module("bootstrap.larg", []);

require('./services/registration.js')(bts);
require('./services/userService.js')(bts);
require('./directives/btsFooterMessage.js')(bts);

var registrationPage = require('./pages/register')(bts);
var forgottonPasswordPage = require('./pages/forgot-password')(bts);


bts.run(["runtimeStates", "routes", function (runtimeStates, routes) {

     //North dakota registration page
     runtimeStates.state('ndregistration',{
        url:'/registration/register',
        title: "BCBSND",
        views:{
            'body@': {
            template: " <mbr-nd-reg class='content-wrapper'></mbr-nd-reg>"    
            }
        }

    });
    runtimeStates.state('register', {
        url: '/register?campaignId',
        data: {
            appConfigMaintenanceApp: 'REGISTER',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE'
        },
        params: {
            userType: '',
            originalUrl: ''
        },
        title: "Login or Register",
        views: {
            'body@': {
                template: bootstrap.templates['page-templates/chevronDetail.html'],
                controller: 'pages.register'
            },
            'content@register': {
                template: require('larg/pages/register/member-information.html'),
                controller: 'pages.register.memberInformation'
            }
        },
        resolve: {
            registerNotifications: function (contentResourceServices) {
                return contentResourceServices.getResourceIdListAsync("Bluecore Notification");
            },
            chevronContent: function (contentResourceServices) {
                return contentResourceServices.getResourceIdListAsync("Bluecore Navigation");
            },
            isActive: function(sessionData, $window) {
                var isOldRegistrationActive = (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH &&
                    sessionData.appConfig.SPLASH.OLD_REGISTRATION_ACTIVE) ? sessionData.appConfig.SPLASH.OLD_REGISTRATION_ACTIVE : {};

                if (isOldRegistrationActive && isOldRegistrationActive.booleanValue === true) {
                    $window.location = "/home/#!/registration/register";
                } else {
                    return true;
                }
            }
        }
    });

    runtimeStates.state('register.memberInformation', {
        url: '/member-information',
        params: {user: ''},
        views: {}
    });

    runtimeStates.state('register.chip14Confirmation', {
        url: '/chip-14-confirmation',
        params: {user: ''},
        title: "Register Confirmation",
        views: {
            'content@register': {
                template: require('larg/pages/register/chip-14-confirmation.html'),
                controller: 'pages.register.chip14Confirmation'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user && $stateParams.user.memberId && $stateParams.user.isCHIP === true) {
                    deferred.resolve($stateParams.user);
                } else {
                    deferred.reject();
                    $window.location = "#/register";
                }
                return deferred.promise;
            }
        }
    });

    runtimeStates.state('register.recoveryInformation', {
        url: '/contact-information',
        params: {user: '', identifyResponse: ''},
        title: "Register Recovery Information",
        views: {
            'content@register': {
                template: require('larg/pages/register/recovery-information.html'),
                controller: 'pages.register.recoveryInformation'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user &&
                    $stateParams.user.memberId &&
                    $stateParams.user.hasProfile === true &&
                    $stateParams.identifyResponse &&
                    $stateParams.identifyResponse.returnCode === 200 &&
                    $stateParams.identifyResponse.returnCodeDescription &&
                    $stateParams.identifyResponse.returnCodeDescription.toUpperCase() === 'SUCCESS') {

                    deferred.resolve({user: $stateParams.user, identifyResponse: $stateParams.identifyResponse});
                } else if ($stateParams.user && !$stateParams.user.memberId){
                    deferred.resolve({ user: $stateParams.user });
                } else {
                    deferred.reject();
                    $window.location = "#/register";
                }
                return deferred.promise;
            }
        }
    });

    runtimeStates.state('register.createLogin', {
        url: '/create-login',
        params: {user: '', identifyResponse: ''},
        title: "Register - Create Login",
        views: {
            'content@register': {
                template: require('larg/pages/register/create-login.html'),
                controller: 'pages.register.createLogin'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user &&
                    $stateParams.user.memberId &&
                    $stateParams.user.hasProfile === true &&
                    $stateParams.identifyResponse &&
                    $stateParams.identifyResponse.returnCode === 200 &&
                    $stateParams.identifyResponse.returnCodeDescription &&
                    $stateParams.identifyResponse.returnCodeDescription.toUpperCase() === 'SUCCESS') {

                    deferred.resolve({user: $stateParams.user, identifyResponse: $stateParams.identifyResponse});
                } else if($stateParams.user && !$stateParams.user.memberId && $stateParams.identifyResponse ) {
                    deferred.resolve({ user: $stateParams.user, identifyResponse: $stateParams.identifyResponse });
                } else {
                    deferred.reject();
                    $window.location = "#/register";
                }
                return deferred.promise;
            }
        }
    });

    var doesForgotPasswordExist = false;
    for (var i = 0; i < routes.length; i++) {
        if (routes[i] && routes[i].state === 'forgotPassword') {
            doesForgotPasswordExist = true;
            break;
        }
    }

    if (!doesForgotPasswordExist) {
        // Forgot Password RunTime States
        runtimeStates.state("forgotPassword", {
            url: "/forgot-password",
            params: {previousState: '', previousStateParams: {}},
            data: {},
            title: "Forgot Password",
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            views: {
                'body@': {
                    template: require('larg/pages/forgot-password.html'),
                    controller: "pages.forgotPassword"
                },
                "content@forgotPassword": {
                    template: require('larg/pages/forgot-password/step1.html'),
                    controller: "pages.forgotPassword.step1"
                }
            }
        });
    }
    runtimeStates.state('forgotPassword.step1', {
        url: '^/forgot-password/step1',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP1',
        data: {isWCAGCompliant: true},
        title: "Forgot Password - Step 1",
        params: {error: ''},
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/step1.html'),
                controller: "pages.forgotPassword.step1"
            }
        }
    });
    runtimeStates.state('forgotPassword.step2', {
        url: '^/forgot-password/step2',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP2',
        data: {isWCAGCompliant: true},
        title: "Forgot Password - Step 2",
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/step2.html'),
                controller: "pages.forgotPassword.step2"
            }
        }
    });
    runtimeStates.state('forgotPassword.step3', {
        url: '^/forgot-password/step3',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP3',
        data: {isWCAGCompliant: true},
        title: "Forgot Password - Step 3",
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/step3.html'),
                controller: "pages.forgotPassword.step3"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep2', {
        url: '^/forgot-password/recovery/step2',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP2',
        data: {},
        title: "Forgot Password - Account Recovery - Step 2",
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/accountRecovery.step2.html'),
                controller: "pages.forgotPassword.accountRecovery.step2"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep3', {
        url: '^/forgot-password/recovery/step3',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP3',
        data: {},
        title: "Forgot Password - Account Recovery - Step 3",
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/accountRecovery.step3.html'),
                controller: "pages.forgotPassword.accountRecovery.step3"
            }
        },
        resolve: {
            phoneNumbers: function ($stateParams, userService) {
                if ($stateParams.user) {
                    return userService.getMaskedUserPhone($stateParams.user.userToken, $stateParams.user.userType);
                }
                return false;
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep4', {
        url: '^/forgot-password/recovery/step4',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
        data: {},
        params: {user: ''},
        title: "Forgot Password - Account Recovery - Step 4",
        views: {
            "content@forgotPassword": {
                template: require('larg/pages/forgot-password/accountRecovery.step4.html'),
                controller: "pages.forgotPassword.accountRecovery.step4"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep4.verify', {
        url: '^/forgot-password/recovery/step4/:userToken/:verificationCode',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
        data: {},
        title: "Forgot Password - Account Recovery - Verification - Step 4",
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                template: '<article></article>',
                controller: "pages.forgotPassword.accountRecovery.step4.verify"
            }
        },
        resolve: {
            verifyCode: function ($stateParams, userService) {
                return userService.verifyCode($stateParams.userToken, $stateParams.verificationCode);
            }
        }
    });
}]);